import React from 'react';
import { bool, func } from 'prop-types';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import './CompensationSummaryConfig.scss';

class CompensationSummaryConfig extends React.Component {
  static propTypes = {
    isConfigVisible: bool,
    saveConfigSettings: func,
    showLastModified: bool
  };

  saveLastModifiedSetting = () => {
    const { saveConfigSettings, showLastModified } = this.props;
    saveConfigSettings({ showLastModified: !showLastModified });
  };

  render() {
    const { isConfigVisible, saveConfigSettings, showLastModified } = this.props;
    if (!isConfigVisible) return null;

    return (
      <div className="comp-sum-content__config-container">
        <div className="comp-sum-content__config-toggle-actions">
          <div className="comp-sum-content__config-toggle-action pxl-text-small">
            <CheckboxInput
              checked={showLastModified}
              className="comp-sum-content__config-toggle-checkbox"
              onClick={this.saveLastModifiedSetting}
            />
            Show Last Modified
          </div>
        </div>
      </div>
    );
  }
}

export default CompensationSummaryConfig;
